import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    nav: {
      home: 'Home', tutorials: 'Tutorials', projects: 'Projects',
      ebooks: 'eBooks', about: 'About', contact: 'Contact',
    },
    home: {
      heroLabel: 'Free Learning Platform',
      heroTitle: 'Master Web Development',
      heroHighlight: 'With Expert Guidance',
      heroSubtitle: 'Learn HTML, CSS, JavaScript, Java, Python and more through hands-on tutorials, real-world projects, and curated eBooks. Build your career today.',
      ctaPrimary: 'Explore Tutorials',
      ctaSecondary: 'View Projects',
      stats: { tutorials: 'Tutorials', projects: 'Projects', ebooks: 'eBooks', Subscribers: 'Subscribers' },
      featuredTutorials: 'Featured Tutorials',
      featuredTutorialsSubtitle: 'Handpicked tutorials to kickstart your learning journey',
      featuredProjects: 'Featured Projects',
      featuredProjectsSubtitle: 'Real-world projects to build your portfolio',
      viewAll: 'View All',
      watchVideo: 'Watch Video',
      viewDetails: 'View Details',
      ebookBanner: {
        label: 'New Release',
        title: 'Master JavaScript: From Zero to Hero',
        subtitle: 'A comprehensive guide covering ES6+, async programming, design patterns, and real-world applications. 400+ pages of expert knowledge.',
        btn: 'Get the eBook',
        price: 'Starting at ₹199',
      }
    },
    tutorials: {
      title: 'All Tutorials',
      subtitle: 'Learn from beginner to advanced – everything in one place',
      all: 'All',
      watchVideo: 'Watch Video',
      noResults: 'No tutorials found in this category.',
    },
    projects: {
      title: 'Our Projects',
      subtitle: 'Real-world projects built with modern technologies',
      viewDetails: 'View Details',
      all: 'All',
    },
    projectDetails: {
      features: 'Key Features',
      techStack: 'Tech Stack',
      viewGithub: 'View on GitHub',
      liveDemo: 'Live Demo',
      back: '← Back to Projects',
      notFound: 'Project not found.',
    },
    ebooks: {
      title: 'eBooks Store',
      subtitle: 'Expand your knowledge with our curated collection of programming eBooks',
      buyNow: 'Download Now',
      pages: 'pages',
    },
    // checkout: {
    //   title: 'Complete Your Purchase',
    //   name: 'Full Name',
    //   email: 'Email Address',
    //   phone: 'Phone Number',
    //   payment: 'Payment Method',
    //   upi: 'UPI',
    //   card: 'Credit / Debit Card',
    //   confirm: 'Confirm Purchase',
    //   cancel: 'Cancel',
    //   success: '🎉 Purchase Successful!',
    //   successMsg: 'Your eBook will be delivered to your email shortly. Thank you!',
    //   close: 'Close',
    //   namePlaceholder: 'John Doe',
    //   emailPlaceholder: 'john@example.com',
    //   phonePlaceholder: '+91 98765 43210',
    //   upiPlaceholder: 'yourname@upi',
    // },
    about: {
      title: 'About Tech By WebCoder',
      subtitle: 'Empowering the next generation of developers',
      missionLabel: 'Our Mission',
      missionTitle: 'Learn. Build. Grow.',
      missionText: 'Tech By WebCoder is a free educational platform dedicated to helping aspiring developers master modern web technologies through structured learning paths, hands-on projects, and expert-crafted content.',
      visionLabel: 'Our Vision',
      visionTitle: 'Accessible Tech Education For All',
      visionText: 'We envision a world where quality tech education is accessible to everyone, regardless of background or financial situation. Our goal is to bridge the skills gap and empower millions of Subscribers worldwide.',
      skillsTitle: 'Technologies We Cover',
      teamTitle: 'Meet the Creator',
      whyTitle: 'Why Choose Us',
      reasons: [
        { title: 'Free Forever', desc: 'All tutorials are completely free – no hidden fees, no paywalls.' },
        { title: 'Beginner Friendly', desc: 'Structured learning paths designed for absolute beginners.' },
        { title: 'Project-Based', desc: 'Learn by building real-world projects you can add to your portfolio.' },
        { title: 'Up-to-Date', desc: 'Content updated regularly to reflect the latest industry standards.' },
        { icon: '🌐', title: 'Multilingual',      desc: 'Tutorials available in both English and Hindi for wider reach.' },
        { icon: '📱', title: 'Mobile Friendly',   desc: 'Learn on any device – desktop, tablet, or smartphone.' },
        { icon: '🔄', title: 'Up-to-Date',        desc: 'Content updated regularly to reflect the latest industry standards.' },
        { icon: '🤝', title: 'Community Support', desc: 'Join our active community and get help from fellow Subscribers.' },
      ],
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'Have a question or suggestion? We\'d love to hear from you.',
      nameLabel: 'Your Name',
      emailLabel: 'Email Address',
      subjectLabel: 'Subject',
      messageLabel: 'Message',
      namePlaceholder: 'John Doe',
      emailPlaceholder: 'john@example.com',
      subjectPlaceholder: 'How can we help?',
      messagePlaceholder: 'Write your message here...',
      submit: 'Send Message',
      sending: 'Sending...',
      successTitle: 'Message Sent!',
      successMsg: 'Thanks for reaching out. We\'ll get back to you within 24 hours.',
      infoTitle: 'Contact Information',
      followUs: 'Follow Us',
    },
    footer: {
      tagline: 'Empowering developers worldwide with free, high-quality education.',
      quickLinks: 'Quick Links',
      resources: 'Resources',
      connect: 'Connect',
      newsletter: 'Newsletter',
      newsletterText: 'Get the latest tutorials delivered to your inbox.',
      subscribe: 'Subscribe',
      emailPlaceholder: 'Enter your email',
      copyright: '© 2026 Tech By WebCoder. All rights reserved.',
      madeWith: 'Made with ❤️ for developers',
    },
    notFound: {
      title: '404',
      subtitle: 'Page Not Found',
      message: 'Oops! The page you\'re looking for doesn\'t exist or has been moved.',
      btn: 'Back to Home',
    },
  },

  hi: {
    nav: {
      home: 'होम', tutorials: 'ट्यूटोरियल', projects: 'प्रोजेक्ट',
      ebooks: 'ई-बुक्स', about: 'हमारे बारे में', contact: 'संपर्क',
    },
    home: {
      heroLabel: 'मुफ्त लर्निंग प्लेटफॉर्म',
      heroTitle: 'वेब डेवलपमेंट सीखें',
      heroHighlight: 'विशेषज्ञ मार्गदर्शन के साथ',
      heroSubtitle: 'HTML, CSS, JavaScript, Java, Python और बहुत कुछ सीखें – व्यावहारिक ट्यूटोरियल, रियल-वर्ल्ड प्रोजेक्ट और ई-बुक्स के माध्यम से। आज ही अपना करियर बनाएं।',
      ctaPrimary: 'ट्यूटोरियल देखें',
      ctaSecondary: 'प्रोजेक्ट देखें',
      stats: { tutorials: 'ट्यूटोरियल', projects: 'प्रोजेक्ट', ebooks: 'ई-बुक्स', Subscribers: 'छात्र' },
      featuredTutorials: 'प्रमुख ट्यूटोरियल',
      featuredTutorialsSubtitle: 'आपकी सीखने की यात्रा शुरू करने के लिए चुने गए ट्यूटोरियल',
      featuredProjects: 'प्रमुख प्रोजेक्ट',
      featuredProjectsSubtitle: 'पोर्टफोलियो बनाने के लिए रियल-वर्ल्ड प्रोजेक्ट',
      viewAll: 'सभी देखें',
      watchVideo: 'वीडियो देखें',
      viewDetails: 'विवरण देखें',
      ebookBanner: {
        label: 'नई रिलीज़',
        title: 'जावास्क्रिप्ट मास्टर करें: शुरुआत से अंत तक',
        subtitle: 'ES6+, async प्रोग्रामिंग, डिज़ाइन पैटर्न और रियल-वर्ल्ड एप्लिकेशन को कवर करने वाली एक व्यापक गाइड।',
        btn: 'ई-बुक लें',
        price: '₹199 से शुरू',
      }
    },
    tutorials: {
      title: 'सभी ट्यूटोरियल',
      subtitle: 'शुरुआती से उन्नत तक – सब कुछ एक जगह',
      all: 'सभी',
      watchVideo: 'वीडियो देखें',
      noResults: 'इस श्रेणी में कोई ट्यूटोरियल नहीं मिला।',
    },
    projects: {
      title: 'हमारे प्रोजेक्ट',
      subtitle: 'आधुनिक तकनीकों से बने रियल-वर्ल्ड प्रोजेक्ट',
      viewDetails: 'विवरण देखें',
      all: 'सभी',
    },
    projectDetails: {
      features: 'मुख्य विशेषताएं',
      techStack: 'टेक स्टैक',
      viewGithub: 'GitHub पर देखें',
      liveDemo: 'लाइव डेमो',
      back: '← प्रोजेक्ट पर वापस',
      notFound: 'प्रोजेक्ट नहीं मिला।',
    },
    ebooks: {
      title: 'ई-बुक स्टोर',
      subtitle: 'हमारे प्रोग्रामिंग ई-बुक्स के संग्रह से अपना ज्ञान बढ़ाएं',
      buyNow: 'अभी खरीदें',
      pages: 'पृष्ठ',
    },
    checkout: {
      title: 'अपनी खरीदारी पूरी करें',
      name: 'पूरा नाम',
      email: 'ईमेल पता',
      phone: 'फ़ोन नंबर',
      payment: 'भुगतान विधि',
      upi: 'UPI',
      card: 'क्रेडिट / डेबिट कार्ड',
      confirm: 'खरीदारी की पुष्टि करें',
      cancel: 'रद्द करें',
      success: '🎉 खरीदारी सफल!',
      successMsg: 'आपकी ई-बुक जल्द ही आपके ईमेल पर भेज दी जाएगी। धन्यवाद!',
      close: 'बंद करें',
      namePlaceholder: 'राम शर्मा',
      emailPlaceholder: 'ram@example.com',
      phonePlaceholder: '+91 98765 43210',
      upiPlaceholder: 'yourname@upi',
    },
    about: {
      title: 'Tech By WebCoder के बारे में',
      subtitle: 'डेवलपर्स की अगली पीढ़ी को सशक्त बनाना',
      missionLabel: 'हमारा मिशन',
      missionTitle: 'सीखें। बनाएं। बढ़ें।',
      missionText: 'Tech By WebCoder एक मुफ्त शैक्षिक प्लेटफॉर्म है जो संरचित सीखने के रास्ते, व्यावहारिक प्रोजेक्ट और विशेषज्ञ सामग्री के माध्यम से वेब प्रौद्योगिकियों में महारत हासिल करने में मदद करता है।',
      visionLabel: 'हमारा विज़न',
      visionTitle: 'सभी के लिए तकनीकी शिक्षा',
      visionText: 'हम ऐसी दुनिया की कल्पना करते हैं जहां गुणवत्तापूर्ण तकनीकी शिक्षा सभी के लिए सुलभ हो, चाहे उनकी पृष्ठभूमि या आर्थिक स्थिति कुछ भी हो।',
      skillsTitle: 'हम जो तकनीकें सिखाते हैं',
      teamTitle: 'निर्माता से मिलें',
      whyTitle: 'हमें क्यों चुनें',
      reasons: [
        { title: 'हमेशा मुफ्त', desc: 'सभी ट्यूटोरियल पूरी तरह मुफ्त हैं – कोई छुपा शुल्क नहीं।' },
        { title: 'शुरुआती के अनुकूल', desc: 'बिल्कुल शुरुआती लोगों के लिए डिज़ाइन किए गए सीखने के रास्ते।' },
        { title: 'प्रोजेक्ट-आधारित', desc: 'रियल-वर्ल्ड प्रोजेक्ट बनाकर सीखें जो आप अपने पोर्टफोलियो में जोड़ सकते हैं।' },
        { title: 'अप-टू-डेट', desc: 'नवीनतम उद्योग मानकों को दर्शाने के लिए नियमित रूप से अपडेट की गई सामग्री।' },
        { icon: '🌐', title: 'बहुभाषी',           desc: 'ट्यूटोरियल अंग्रेजी और हिंदी दोनों में उपलब्ध हैं।' },
        { icon: '📱', title: 'मोबाइल फ्रेंडली',   desc: 'किसी भी डिवाइस पर सीखें – डेस्कटॉप, टैबलेट या स्मार्टफोन।' },
        { icon: '🔄', title: 'अप-टू-डेट',         desc: 'नवीनतम उद्योग मानकों को दर्शाने के लिए सामग्री नियमित रूप से अपडेट होती है।' },
        { icon: '🤝', title: 'कम्युनिटी सपोर्ट',  desc: 'हमारी सक्रिय कम्युनिटी से जुड़ें और साथी छात्रों से मदद पाएं।' },
      ],
    },
    contact: {
      title: 'संपर्क करें',
      subtitle: 'कोई प्रश्न या सुझाव है? हम आपसे सुनना पसंद करेंगे।',
      nameLabel: 'आपका नाम',
      emailLabel: 'ईमेल पता',
      subjectLabel: 'विषय',
      messageLabel: 'संदेश',
      namePlaceholder: 'राम शर्मा',
      emailPlaceholder: 'ram@example.com',
      subjectPlaceholder: 'हम कैसे मदद कर सकते हैं?',
      messagePlaceholder: 'अपना संदेश यहाँ लिखें...',
      submit: 'संदेश भेजें',
      sending: 'भेज रहे हैं...',
      successTitle: 'संदेश भेज दिया!',
      successMsg: 'संपर्क करने के लिए धन्यवाद। हम 24 घंटों में आपसे संपर्क करेंगे।',
      infoTitle: 'संपर्क जानकारी',
      followUs: 'हमें फॉलो करें',
    },
    footer: {
      tagline: 'मुफ्त, उच्च-गुणवत्ता वाली शिक्षा के साथ दुनिया भर के डेवलपर्स को सशक्त बनाना।',
      quickLinks: 'त्वरित लिंक',
      resources: 'संसाधन',
      connect: 'जुड़ें',
      newsletter: 'न्यूज़लेटर',
      newsletterText: 'नवीनतम ट्यूटोरियल अपने इनबॉक्स में पाएं।',
      subscribe: 'सब्सक्राइब करें',
      emailPlaceholder: 'ईमेल दर्ज करें',
      copyright: '© 2026 Tech By WebCoder. सर्वाधिकार सुरक्षित।',
      madeWith: 'डेवलपर्स के लिए ❤️ से बनाया',
    },
    notFound: {
      title: '404',
      subtitle: 'पेज नहीं मिला',
      message: 'क्षमा करें! आप जिस पेज को खोज रहे हैं वह मौजूद नहीं है या हटा दिया गया है।',
      btn: 'होम पर वापस',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('tlp-lang') || 'en');

  const switchLang = (l) => {
    setLang(l);
    localStorage.setItem('tlp-lang', l);
  };

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
